import * as React from "react";
import type { SVGProps } from "react";
const SvgVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M23 7h1a1 1 0 0 0-1.581-.814zm-7 5-.581-.814a1 1 0 0 0 0 1.628zm7 5-.581.814A1 1 0 0 0 24 17zm-.581-10.814-7 5 1.162 1.628 7-5zm-7 6.628 7 5 1.162-1.628-7-5zM24 17V7h-2v10zM3 6h11V4H3zm11 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v10h2V7zm0 10a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H3v2h11zM3 18a1 1 0 0 1-1-1H0a3 3 0 0 0 3 3zm-1-1V7H0v10zM2 7a1 1 0 0 1 1-1V4a3 3 0 0 0-3 3z"
    />
  </svg>
);
export default SvgVideo;
